export const billingExportPath = {
  RETRIEVE_BATCH: '/billing/batch/retrieve',
  PULL_BILLING_EXPORT: '/billing/pull',
  //  BOPS-440 / RA-2285 — the blockers a pull with the same body would hit, as a JSON array.
  BILLING_BLOCKERS: '/billing/blockers',
};

/**
 * BOPS-397 / RA-2203 — the billing export's refresh state, read from billing-service (which launches
 * the Dagster run on close) rather than from the automation service that serves the file. Mirrors the
 * invoice documents read (`/api/billing/dagster/documents`, BOPS-364); shipped in billing-service #342.
 * provider-portal's interceptor already prefixes `/api`, so this is the remainder.
 */
export const billingExportRefreshPath = '/billing/dagster/billing-export';
